module.exports = __webpack_public_path__ + "static/digitaltrends-7fcf92ebce95b43839a029b83784dd12.png";